import React from 'react';

interface SkeletonProps {
  className?: string;
}

const Skeleton: React.FC<SkeletonProps> = ({ className = 'h-4 w-full' }) => {
  return (
    <div
      className={`animate-pulse-fast bg-gray-300 dark:bg-gray-700 rounded ${className}`}
    ></div>
  );
};

export default Skeleton;
